function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m226 0c-24.814 0-45 20.186-45 45v16l30 15h15 15l30-15v-16c0-24.814-20.186-45-45-45z",
  fill: "#ff6a4d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271 61v-16c0-24.814-20.186-45-45-45v76h15z",
  fill: "#e64d2e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 452c6.951 34.232 38.716 60 75 60s69.049-25.768 76-60l-32.588-15h-97.588z",
  fill: "#474f54"
}), /*#__PURE__*/React.createElement("path", {
  d: "m75 482c-24.814 0-45-20.186-45-45s20.186-45 45-45 46 20.186 46 45-21.186 45-46 45z",
  fill: "#f2f9ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m151 182h-91l-30 30v90l30 15h91l45-15v-81l-15-9z",
  fill: "#ff9100"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30 152v60h151l15-7.765-15-7.235v-45z",
  fill: "#fabe2c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m241 452h-241v-15c0-57.99 48.01-105 106-105l25-15h140v110z",
  fill: "#ff6a4d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 302h211v30h-211z",
  fill: "#32393f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m316 377.899v56.4l-15 17.701h-60v-120h-30c-16.5 0-30-13.5-30-30v-75h90v45c16.5 0 30 13.5 30 30v60z",
  fill: "#575f64"
}), /*#__PURE__*/React.createElement("path", {
  d: "m316 377.899v56.4l-15 17.701h-60v-120h-15v-105h45v45c16.5 0 30 13.5 30 30v60z",
  fill: "#474f54"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m271 212v-15c0-24.814-20.186-45-45-45s-45 20.186-45 45v30c0 24.853 20.147 45 45 45h121c24.853 0 45-20.147 45-45v-15z",
  fill: "#ff6a4d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392 227v-15h-121v-15c0-24.814-20.186-45-45-45v120h121c24.853 0 45-20.147 45-45z",
  fill: "#e64d2e"
})), /*#__PURE__*/React.createElement("path", {
  d: "m241 76h-15-15l-30 15v15c0 24.814 20.186 46 45 46s45-21.186 45-46v-15z",
  fill: "#ffe1ba"
}), /*#__PURE__*/React.createElement("path", {
  d: "m271 106v-15l-30-15h-15v76c24.814 0 45-21.186 45-46z",
  fill: "#ffbfab"
}), /*#__PURE__*/React.createElement("path", {
  d: "m226 61h-45v30h45 75v-30z",
  fill: "#474f54"
}), /*#__PURE__*/React.createElement("path", {
  d: "m226 61h75v30h-75z",
  fill: "#32393f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m433.338 305.354c-1.655-11.675-4.937-34.673-11.484-80.479l-59.854-27.875v120c0 23.663-20.385 45-46 45h-15v90h30 151l30-15v-30c0-47.988-33.105-89.824-78.662-101.646z",
  fill: "#e64d2e"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m452 242h-45c-24.814 0-45-20.186-45-45s20.186-45 45-45h45z",
  fill: "#ff6a4d"
})), /*#__PURE__*/React.createElement("path", {
  d: "m441.508 362.456-4.362 16.668-25.351-12.453c-28.93 10.411-49.795 37.859-49.795 70.329 0 41.353 33.647 75 75 75s75-33.647 75-75c0-39.809-31.273-72.16-70.492-74.544z",
  fill: "#32393f"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m437 392c-24.814 0-45 20.186-45 45s20.186 45 45 45 45-20.186 45-45-20.186-45-45-45z",
  fill: "#dfe7f4"
})), /*#__PURE__*/React.createElement("path", {
  d: "m451.854 434.876-10.345-72.42c-1.523-.092-2.965-.456-4.509-.456-8.882 0-17.291 1.824-25.204 4.671l10.351 72.453z",
  fill: "#c7cfe1"
}));

var SvgDonateFoodIcon = function SvgDonateFoodIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDonateFoodIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/donate_food_icon.a91ca631.svg";
export { ForwardRef as ReactComponent };